// importing material UI components

import { ScreenProps } from "../../constant/types";
import { HEADER_LOGO } from "../../constant/constant";
import { useNavigate } from "react-router-dom";
import HoverMenu from "../Menu/HoverMenu";
import FirebaseAuth from "../../firebase/FirebaseAuth";
import HamburgerMenu from "../Menu/HamburgerMenu";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setSubcriptionPopUp } from "../../reducers/appReducer";
import "./Header.css";

function Header({ mainTitle, subTitle }: ScreenProps) {
  const [isTop, setIsTop] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const openPopup = () => {
    dispatch(setSubcriptionPopUp(true));
  };
  
  useEffect(() => {
    const handleScroll = () => {
      const position = window.pageYOffset;
      if (position === 0) {
        setIsTop(true);
      } else {
        setIsTop(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // Initial check
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <header className="landing-header">
      <div className={`header ${isTop ? 'header-transparent' : ''}`}>
        <HamburgerMenu />
        <img src={HEADER_LOGO} className="header-logo" alt="autorig-avt" onClick={() => { navigate("/"); window.scroll({ top: 0, left: 0, behavior: 'smooth' }) }} />
        <div className="menu">
          <HoverMenu />
        </div>
        <div className="login">
          <div className="credit-btn" onClick={openPopup}>
          <i className="fa-solid fa-coins"></i>
            <div className="credit">0 Credits</div>
          </div>
          <FirebaseAuth />
        </div>
        {/* <FacebookLogin appId="283954181115281" autoLoad={true} fields="name,email,picture" callback={responseFacebook} icon="fa-facebook" /> */}
      </div>
    </header>
  );
}
// const responseGoogle = (response) => { console.log(response); }; 
// const responseFacebook = (response) => { console.log(response); };

export default Header;
